import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { scrollToId } from "@/lib/lenis";
import { profile } from "@/data/portfolio";

export const Footer = () => {
  const [time, setTime] = useState("");

  useEffect(() => {
    const tick = () =>
      setTime(
        new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit" })
      );
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer
      className="border-t border-white/5 bg-[#0A0B12]/80 py-10"
      data-testid="site-footer"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 sm:flex-row sm:px-8 lg:px-16">
        <span className="font-mono text-xs tracking-widest text-slate-500">
          © 2026 {profile.name} — crafted with Python &amp; espresso
        </span>
        <span className="font-mono text-xs tracking-widest text-cyan-400" data-testid="footer-clock">
          {profile.location} · {time}
        </span>
        <button
          data-testid="back-to-top-button"
          onClick={() => scrollToId("#home")}
          aria-label="Back to top"
          className="rounded-full border border-white/10 p-3 text-slate-400 transition-all duration-300 hover:border-violet-400/60 hover:text-violet-300 hover:glow-violet"
        >
          <ArrowUp size={16} />
        </button>
      </div>
    </footer>
  );
};
